import { ReactNode } from "react";
import styles from "./PagesWrapper.module.css";
import MainPage from "./MainPage";
import { Section } from "../../../types";
import useWindowDimensions from "../../util/useWindowDimensions";

const PagesWrapper = ({
  children,
  header,
  header2,
  header3,
  image,
  hasTop = true,
  data,
}: {
  children: ReactNode;
  header?: string;
  header2?: string;
  header3?: string;
  image?: string;
  hasTop?: boolean;
  data: Section[];
}) => {
  const { width } = useWindowDimensions();
  const isMobile = width < 768;

  if (!hasTop) {
    if (isMobile) {
      return (
        <div
          style={{
            background: "linear-gradient(to right, #e5e7e9, #aeb6bf)",
            maxWidth: "100%",
            padding: "1em",
          }}
        >
          {children}
        </div>
      );
    }

    return (
      <MainPage data={data}>
        <div
          style={{
            background: "linear-gradient(to right, #e5e7e9, #aeb6bf)",
            padding: "25px",
          }}
        >
          {children}
        </div>
      </MainPage>
    );
  }

  if (isMobile) {
    return (
      <div
        style={{
          background: "linear-gradient(to right, #e5e7e9, #aeb6bf)",
          padding: "1em",
        }}
      >
        <div className={styles.artistStatement}>
          <div className={styles.artistStatementH1}>
            <div
              style={{ fontSize: "5vh" }}
              dangerouslySetInnerHTML={{ __html: header ?? "" }}
            />

            {header2 === "uwe.s (Uwe Scheutzel)" ? (
              <p style={{ marginTop: "-5px" }}>{header2}</p>
            ) : (
              <p>{header2}</p>
            )}
          </div>
          <div
            className={styles.artistStatementLB}
            dangerouslySetInnerHTML={{ __html: header3 ?? "" }}
          ></div>
          <img className={styles.portImg} src={image} alt={"Portraet"} />
        </div>
        {children}
      </div>
    );
  }

  return (
    <MainPage data={data}>
      <div
        style={{
          background: "linear-gradient(to right, #e5e7e9, #aeb6bf)",
          padding: "15px",
        }}
      >
        <div className={styles.topWrapper}>
          <div className={styles.artistStatement}>
            <div className={styles.artistStatementH1}>
              <div dangerouslySetInnerHTML={{ __html: header ?? "" }} />

              {header2 === "uwe.s (Uwe Scheutzel)" ? (
                <p style={{ marginTop: "-5px" }}>{header2}</p>
              ) : (
                <p>{header2}</p>
              )}
            </div>
            <div
              className={styles.artistStatementLB}
              dangerouslySetInnerHTML={{ __html: header3 ?? "" }}
            ></div>
          </div>
          <div className={styles.portImgWrapper}>
            <img className={styles.portImg} src={image} alt={"Portraet"} />
          </div>
        </div>
        {children}
      </div>
    </MainPage>
  );
};
export default PagesWrapper;
